<div class="component button-example">
    <h2>Button</h2>
    <p>
        Width of buttons is determined by its containing elements width.
    </p>

    <div class="example">
        <sbw-button [type]="'default'" [text]="'Default Button Demo'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'preferred'" [text]="'Preferred Button Demo'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'previous'" [text]="'Back Button Demo'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [name]="'DemoButton'" [type]="'default'" [text]="'Button with click event'" onClickState="activated" (clicked)="buttonClicked($event)"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'default'" [text]="'Button with internal link'" [link]="'/agent'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'default'" [text]="'Button with external link'" [link]="'http://www.erdetsnartfredag.dk/'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'default'" [text]="'Button with external link forced link'" [link]="'/agent'" [forceLink]="true"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'preferred'" [state]="'spinner'" [text]="'Button with spinner'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'preferred'" [state]="'disabled'" [text]="'Disabled button'"></sbw-button>
    </div>
    <div class="example">
        <sbw-button [type]="'preferred'" [(state)]="buttonState" [text]="'Button state two way binding'" (clicked)="buttonClicked($event)"></sbw-button>
    </div>
</div>